let Event = require("cocos/framework/components/event")
const EvtRemove = "TipRemove";

let StartPanelAdTip = xClass("StartPanelAdTip", Event, function () {
    return cc.CSLoader.createNode("cocos/h5ad_tip.csb")
})

StartPanelAdTip.prototype.ctor = function(msg) {
    let self = this;
    
    self.getChildByName("main").getChildByName("label").setString(msg);
    self.bind(self);

    self.action = cc.CSLoader.createTimeline("cocos/h5ad_tip.csb");
    self.timeoutFlag = 0;
    // 代码微调
    let whitebubblespeak = self.getChildByName("main").getChildByName("whitebubblespeak")
    // whitebubblespeak.setContentSize(150,70)
    whitebubblespeak.setPosition(20,74)
    // whitebubblespeak.setContentSize(150,70)
    let label = self.getChildByName("main").getChildByName("label")
    label.setPosition(8,-42)
}

StartPanelAdTip.prototype.close = function() {
    let self = this;

    if (self.action && self.action.isPlaying()) {
        if (self.action.getCurrentFrame() < 168) {
            self.action.setCurrentFrame(168);
        }
    }
}

StartPanelAdTip.prototype.onEnter = function() {
    let self = this;
    cc.Node.prototype.onEnter.call(self);
    
    self.getChildByName("main").setVisible(false);
    self.timeoutFlag = setTimeout(function(){
        self.getChildByName("main").setVisible(true);
        self.runAction(self.action)
        self.action.gotoFrameAndPlay(0);
        self.action.setLastFrameCallFunc(function() {
            self.action.clearLastFrameCallFunc();
            self.removeFromParent(true);
        });
    }, 150);

}
StartPanelAdTip.prototype.onRemove = function(handler) {
    let self = this;
    self.on(EvtRemove, handler);
}

StartPanelAdTip.prototype.onExit = function() {
    let self = this;
    self.dispatchEvent({name: EvtRemove});
    cc.Node.prototype.onExit.call(self);
}

StartPanelAdTip.prototype.cleanup = function() {
    let self = this;
    self.removeAllEventListeners();
    self.action = null;
    cc.Node.prototype.cleanup.call(self);


    if (self.timeoutFlag != 0)
    {
        clearTimeout(self.timeoutFlag);
        self.timeoutFlag = 0;
    }
}
module.exports = StartPanelAdTip
